<template>
  <div class="container">
    <div class="productCenter">
      <header>发展历程</header>
      <footer>Product&nbsp;Center</footer>
    </div>
    <div class="div">
      <div class="red">
        <span class="big">创</span> <span class="ss">伟 嘉 品 牌</span>
        <span class="big">圆</span> <span class="ss">百 年 梦 想</span>
      </div>
    </div>
    <div class="content">
      <div class="left">
        <div class="box">
          <header>DEVELOPMENT</header>
          <div>HISTORY</div>
          <div class="name">大伟嘉历程</div>
          <div class="ad" @click="year < max ? year++ : false">
            <div :class="year == max ? 'add' : 'add1'"></div>
          </div>
          <div class="top">
            <a :href="'#' + Number(year)">{{ year }}</a>
          </div>
          <div class="bottom">
            <a :href="'#' + Number(year - 1)">{{ year - 1 }}</a>
          </div>
          <div class="re" @click="year - 1 > min ? year-- : false">
            <div :class="year - 1 == min ? 'reduce' : 'reduce1'"></div>
          </div>
          <div class="ooo">Development History</div>
        </div>

      </div>
      <div class="right">
        <div id="time-line">
          <div class="item" v-for="item in activities" :key="item.id">
            <div class="before"><div class="circle"></div></div>
            <div class="item-index">
              <span class="big" :id="item.name">{{ item.name }}</span>
              <span class="nian">年</span>
            </div>
            <div class="item-content">
              <ul>
                <li v-for="item1 in item.list" :key="item1.id" v-html="delHtmlTag(item1.name)" >
                  {{ item1.name }}
                </li>
              </ul>
            </div>
            <div class="after"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      activities: [],
      year: 0,
      max: 0,
      min: 0,
    };
  },
  methods: {

    delHtmlTag(str) {
      console.log(str)
      // if (str != null || str == undefined  ) {
      //   console.log(str.replace(/<[^>]+>/g, ""))
      //   return str.replace(/<[^>]+>/g, "");
      if (str != null || str == undefined  ) {
        let estr = str
            // .replace(/<[^>]+>/g, "")
                .replace(/&lt;/g,"<")
                .replace(/&gt;/g,">")
                .replace(/&amp;/g, "")
                .replace(/&nbsp;/g,"")
                .replace(/nbsp;/g,"")
                .replace(/&quot;/g, '"')
        ;
        console.log(estr)
        return estr

      }else {
        console.log(222);
      }

    },
  },
  async created() {
    this.activities = (
      await axios({
        method: "get",
        // url: "/xm/index.php/index/index/getHistory",
        url: "http://dwj.test.jianong.com/index.php/index/index/getHistory",

        params: {},
      })
    ).data.data.reverse();
    this.year = this.activities[0].name;
    this.max = this.activities[0].name;
    this.min = this.activities[this.activities.length - 1].name;
  },
};
</script>

<style lang="less" scoped>

 /deep/ span{
    font-size: 3.5vw;
    line-height: 1.3;
   color: #646464;
  }

 /deep/ img{
   width:45vw!important;
   margin-top: 1vw;
  }

/deep/.productCenter {
  display: flex;
  flex-direction: column;
  justify-content: center;
  header {
    font-size: 4.5vw;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 700;
    color: #d7000f;
    margin-top: 8vw;
    text-align: center;
    letter-spacing:0.15vw;
  }
  footer {
    font-size: 3.8vw;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #646464;
    margin-top: 1.2vw;
    text-align: center;
    margin-bottom: 6vw;
  }

}

// 时间线
#time-line {
  .before {
    width: 1.5625vw;
    height: 1.5625vw;
    border-radius: 100%;
    border: 0.1563vw solid #d3d3d3;
    position: absolute;
    left: -1.5625vw;
    top: -0.5208vw;
    .circle {
      width: 0.7813vw;
      height: 0.7813vw;
      border-radius: 100%;
      background-color: #d3d3d3;
      position: absolute;
      left: 0.4167vw;
      top: 0.3646vw;
    }
  }
  .after {
    width: 0.1563vw;
    height: calc(100% + 2.7604vw);
    background-color: #dadada;
    position: absolute;
    top: calc(1.8229vw + -0.5208vw);
    left: -0.6771vw;
  }
}
.item {
  padding-left: 0.5625vw;
  width: calc(100% - 1.5625vw);
  height: auto;
  position: relative;
  margin-bottom: 7vh;
  &:last-child .after {
    display: none;
  }
}

.item-index {
  line-height: 0.625vw;
  font-size: 0.625vw;
  position: relative;
  left: 0.8667vw;
  color: #656565;
  .big {
    color: #d7000f;
    font-size: 5vw;
    font-weight: 700;
    margin-right: 0.5208vw;
  }
}
.item-content {
  margin-top: 3vh;
  left: 2.1667vw;
  width: 100%;
  height: auto; /*由内容决定*/
  position: relative;
  ul {
    margin-top: 3vw;
    width: 95%;
    li {
      margin-top: 2.8vw;
      line-height: 2.9vw;
      position: relative;
      width: 100%;
      margin-bottom: 1.5625vw;
      &::before {
        top: 1.5vw;
        left: -2vw;
        position: absolute;
        /*margin-right: 1.5vw;*/
        content: "";
        width: 1.5vw;
        height: 1.5vw;
        display: inline-block;
        border-radius: 100%;
        background-color: #d7000f;
      }
    }
  }
}

.container {
  position: relative;
  margin-bottom: 10vw;
  .div {
    width: 100%;
    height: 6vw;
    margin-top: 1.0417vw;
    margin-bottom: 4.1667vw;
    .red {
      padding-left: 0.1667vw;
      line-height: 5.5vw;
      right: 0;
      width: 56.25vw;
      height: 5.5vw;
      position: absolute;
      background-color: #d7000f;
      color: #ffffff;
      .big {
        margin-left: 3.125vw;
        font-size: 5vw;
        color: #ffffff;
        font-weight: 500;
      }
    }
  }
  .content {
    display: flex;
    position: relative;
    margin-top: 10vw;
    .left {
      flex: 40;
      .box {
        position: sticky;
        top: 0;
        box-sizing: border-box;
        padding: 0 4.0417vw;
margin-left: 5vw;
        overflow: hidden;
        width: 36vw;
        height: 55vw;
        border-radius: 1.0417vw;
        background-image: url("./images/bg.png");
        background-size: 100%;
        background-repeat:no-repeat;
        font-size: 3.5vw;
        color: #e0a6a8;

        header {
          margin-top: 2.5vw;
          font-weight: 200;
          text-align: right;
          margin-bottom: 2.5vw;
        }
        .ooo{
          font-size: 2.8vw;
          margin-top: 2.5vw;
          font-weight: 200;
          text-align: right;
        }
        div {
          text-align: right;
          font-weight: 200;
          margin-bottom: 2.5vw;
        }
        .name {
          color: #ffffff;
          font-size: 3.8vw;
          font-weight: 400;
          margin-bottom: 4vw;
        }
        .ad {
          position: relative;
          height: 3vw;
          .add {
            position: absolute;
            right: 1.5vw;
            cursor: pointer;
            width: 4vw;
            height: 2.5vw;
            background-image: url("./images/xiayibu.png");
            background-size: 100%;
          }
          .add1 {
            position: absolute;
            right: 1.5vw;
            cursor: pointer;
            background-image: url("./images/xiayibu1.png");
            width: 4vw;
            height: 2.5vw;
            transform: rotate(180deg);
            background-size: 100%;
          }
        }
        .re {
          position: relative;
          height: 3vw;
          .reduce {
            position: absolute;
            right: 1.5vw;
            cursor: pointer;
            width: 4vw;
            transform: rotate(180deg);
            height: 2.5vw;
            background-image: url("./images/xiayibu.png");
            background-size: 100%;
          }
          .reduce1 {
            position: absolute;
            right: 1.5vw;
            cursor: pointer;
            width: 4vw;
            height: 2.5vw;
            background-image: url("./images/xiayibu1.png");
            background-size: 100%;
          }
        }
        .top {
          display: block;
          a {
            font-size: 3.5vw;
            font-weight: 400;
            color: #fdf6f7;
          }
        }
        .bottom {
          a {
            font-size: 3.5vw;
            font-weight: 400;
            color: #fdf6f7;
          }
        }
      }
    }
    .right {
      flex: 64;
      margin-left: 5vw;
    }
  }
}
  .ss{
    font-size: 3vw!important;
    color: #ffffff;
  }
</style>
